import { Outlet, createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/it-operation-core/_detail')({
  component: RouteComponent
});
function RouteComponent() {
  return <Outlet />;
}